/**
 * parentGoals.js — MOAT 1.0 Phase 10 · simple parent goals → MWQ builds the plan.
 * Stored locally (mwq_parent_goals_v1, per active child). Goals steer recommendations
 * and Focus Day defaults; they never lock anything.
 */
import { getActiveChildId } from "@/lib/children";
import { REWARDS } from "@/lib/canonical";

export const GOALS = [
  { id: "maths", label: "Get stronger at Maths", e: "➗", subject: "maths", to: "/start/maths" },
  { id: "reading", label: "Improve reading", e: "📚", subject: "english", to: "/reading" },
  { id: "english", label: "Improve English", e: "📖", subject: "english", to: "/start/english" },
  { id: "year", label: "Prepare for my year", e: "🎯", subject: null, to: "/learn-pathways" },
  { id: "curriculum", label: "Follow my curriculum", e: "🗂️", subject: null, to: "/curriculum" },
  { id: "science", label: "Explore science", e: "🔬", subject: "science", to: "/start/science" },
  { id: "coding", label: "Build coding skills", e: "💻", subject: "ict", to: "/learn/code-quest" },
  { id: "world", label: "Explore the world", e: "🌍", subject: "geography", to: "/globe" },
  { id: "balanced", label: "Balanced learning", e: "⚖️", subject: null, to: "/learn-pathways" },
];

const key = () => `${REWARDS.goalsKey}:${getActiveChildId() || "default"}`;
export function loadGoals() { try { return JSON.parse(localStorage.getItem(key()) || "[]") || []; } catch { return []; } }
export function saveGoals(list) { try { localStorage.setItem(key(), JSON.stringify(list.slice(0, 3))); window.dispatchEvent(new CustomEvent("mwq-goals-changed")); } catch { /* ignore */ } return list; }
export function toggleGoal(id, extra = {}) {
  const cur = loadGoals(); const g = GOALS.find((x) => x.id === id); if (!g) return cur;
  return saveGoals(cur.some((x) => x.id === id) ? cur.filter((x) => x.id !== id) : [...cur, { id, subject: g.subject, at: Date.now(), ...extra }]);
}
export const primaryGoal = () => { const g = loadGoals()[0]; return g ? { ...GOALS.find((x) => x.id === g.id), ...g } : null; };
